import { Helmet } from "react-helmet-async";

export type JsonLdObject = Record<string, unknown>;

export interface StructuredDataProps {
  /** Um ou mais objetos JSON-LD (Organization, SoftwareApplication, BreadcrumbList, etc.). */
  data: JsonLdObject | JsonLdObject[];
}

/**
 * Injeta dados estruturados (JSON-LD) no head da página.
 * Cada objeto é emitido em um <script type="application/ld+json"> separado.
 * Não inclui reviews, aggregateRating ou dados inventados.
 */
export function StructuredData({ data }: StructuredDataProps) {
  const items = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {items.map((obj, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(obj) }}
        />
      ))}
    </Helmet>
  );
}
